module.exports = __webpack_public_path__ + "static/media/Tupe6.31872cb1.webp";